import DataTable from "react-data-table-component";
// import { Spinner } from "components/spinner";

const customStyles = {
   tableWrapper: {
      style: {
         overflowX: "visible",
         overflowY: "visible",
      },
   },
   table: {
      style: {
         position: "relative",
         overflowX: "visible",
         overflowY: "visible",
      },
   },
   header: {
      style: {
         display: "none",
      },
   },
   subHeader: {
      style: {
         border: "none",
         boxShadow: "none",
      },
   },
   head: {
      style: {
         border: "none",
         boxShadow: "none",
      },
   },
   headRow: {
      style: {
         fontWeight: 'bold',
         fontSize: '1.2rem',
         boxShadow: "none",
         marginBottom: "5px",
         textAlign: 'center',
         color: '#2196F3',
         padding: '0 1.76rem'
      },
   },
   rows: {
      style: {
         fontWeight: 'bold',
         fontSize: '1.4rem',
         color: '#979797',
         minHeight: '6.6rem',
         padding: '0 1rem',
         textTransform: 'capitalize',


      },
      selectedHighlightStyle: {
         "&:nth-of-type(n)": {
            backgroundColor: "#3577e51f",
         },
      },
   },
   headCells: {
      style: {
         paddingLeft: "8px",
         paddingRight: "8px",
         fontSize: "1.45rem",
         fontWeight: 500,
      },
   },
   cells: {
      style: {
         wordBreak: 'break-word',

         "&:first-child": {
            color: "#3B3B42",
            fontWeight: 'bold',

            "&:first-child": {
               whiteSpace: 'unset !important',
               textOverflow: 'unset !important',
            }


         },
      },
   },
};

export const Table = ({ isLoading, columns, data }) => {
   return (
      <DataTable
         progressPending={isLoading}
         // progressComponent={
         //    <div style={{ height: "200px", display: "flex", alignItems: "center" }}>
         //       <Spinner />
         //    </div>
         // }
         customStyles={customStyles}
         // selectableRows
         data={data}
         columns={columns}
      // defaultSortFieldId={1}
      // selectableRowsSingle
      // onSelectedRowsChange={(dt) => onRowSelected(dt?.selectedRows[0])}
      // responsive
      />
   );
};
